/** Resolve cover or banner image URL from business record fields. */
export function businessMediaUrl(business, field, idField) {
  const media = business?.[field]
  return (
    media?.thumbnail_url ??
    media?.direct_upload_url ??
    (business?.[idField] ? `/api/media_attachments/${business[idField]}` : null)
  )
}
